
<div class="dtf-olp" style="background-color: #E6E6E6;">

    <div *ngIf="!isCanadaPortal" class="container_dashboard" >
        <div class="dtf-dashboard" style="padding-top: 41px; padding-bottom: 0px;">
         
          <div class="example-button-row">
            <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState" (change)="onChangeButton($event)">
              <mat-button-toggle  [value]="toggleEnum.Option7" [class.selected]="selectedState === toggleEnum.Option7">Make a Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option1" [class.selected]="selectedState === toggleEnum.Option1">Principal Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option3" [class.selected]="selectedState === toggleEnum.Option3">Statement Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option6" [class.selected]="selectedState === toggleEnum.Option6">Recurring Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option4" [class.selected]="selectedState === toggleEnum.Option4">Manage Bank Profile</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option2" [class.selected]="selectedState === toggleEnum.Option2" style="background-color: #00566A !important; color: white !important;">Payment History</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option8" [class.selected]="selectedState === toggleEnum.Option8">Help</mat-button-toggle>
            </mat-button-toggle-group>
            </div>
        </div> 
    </div>

    <div class="container_dashboard" >
        <div style="padding-bottom: 21px;">
            <div class="cardlike">
                <h1 *ngIf="isCanadaPortal">{{ 'paymenthistory.header' | translate }}</h1>
                <h1 *ngIf="!isCanadaPortal">{{ 'paymenthistory.header' | translate }}</h1>
            
                <div style="font-size: large;">
                    <p> You may have upcoming <a href="{{this.baseRedirect}}/home/scheduledpayment"><span
                                style="font-weight: bold; color: #00566A;">Scheduled Payments</span></a>. Click here to view the
                        details
                        and dates. &nbsp;
                        <span>
                            <button matIconButton disabled aria-label="Example icon button with an open in new tab icon"
                                style="background: transparent; border: none; box-shadow: none;">
                                <a href="{{this.baseRedirect}}/home/scheduledpayment"><mat-icon
                                        style="color: #00566A; height: 21px;">open_in_new</mat-icon></a>
                            </button>
                        </span>
                    </p>
                </div>
            
                <div *ngIf="step1" style=" padding-bottom: 15px; padding-left: 10px;">
                    <!-- Search Box -->
                    <div class="accountflex">
                        <h1 class="mercedes-me-login__column-headline2"></h1>
                        <mat-form-field appearance="outline" style="width: 100%;">
                            <mat-label *ngIf="isCanadaPortal">{{ 'paymenthistory.search1' | translate }}</mat-label>
                            <mat-label *ngIf="!isCanadaPortal">{{ 'paymenthistory.search1' | translate }}</mat-label>
                            <input matInput style="outline: none;" placeholder="Enter Account Number" #input type="number"
                                (keyup)="applyFilterAccPr($event.target.value)" [(ngModel)]="value">
                            <img matSuffix class="example-form-img"
                                src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                        </mat-form-field>
                    </div>
                </div>
            </div>
                    <br>
                    <!-- Filters -->
                    <div *ngIf="step2">
                        <div class="card payment-history-filter-card" style="margin-left: 26px; width: 97%; padding: 10px;">
            
                            <div class="row">
            
                                <!-- Search 1: Account Number -->
                                <div class="col-lg-4 col-md-4 col-sm-2 col-6 search-account">
                                    <p class="filter" style="font-weight: bold; font-size: 15px;">
                                        {{ 'paymenthistory.filter1' | translate }}
                                    </p>
                                    <mat-form-field appearance="outline" style="width: 100%;">
                                        <mat-label>{{ 'paymenthistory.filter1label' | translate }}</mat-label>
                                        <input matInput (keyup)="applyFilterAcc($event.target.value)" type="text">
                                        <img matSuffix class="example-form-img"
                                            src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                                    </mat-form-field>
                                </div>
            
                                <!-- Search 2: Payment Method -->
                                <div class="col-lg-4 col-md-4 col-sm-2 col-6 search-method">
                                    <p class="filter" style="font-weight: bold; font-size: 15px;">
                                        {{ 'paymenthistory.filter2' | translate }}
                                    </p>
                                    <mat-form-field appearance="outline" style="width: 100%;">
                                        <mat-label>{{ 'paymenthistory.filter2label' | translate }}</mat-label>
                                        <input matInput (keyup)="applyFilterpaymentmethod($event.target.value)" type="text">
                                        <img matSuffix class="example-form-img"
                                            src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                                    </mat-form-field>
                                </div>
            
                                <!-- Search 3: Date -->
                                <div class="col-lg-4 col-md-4 col-sm-5 col-6 search-date">
                                    <p class="filter" style="font-weight: bold; font-size: 15px;">
                                        {{ 'paymenthistory.filter3' | translate }}
                                    </p>
                                    <mat-form-field appearance="outline" style="width: 100%;">
                                        <mat-label>{{ 'paymenthistory.filter3label' | translate }}</mat-label>
                                        <input matInput [matDatepicker]="datepicker"
                                            (dateChange)="applyFilterDate($event.target.value)">
                                        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                                        <mat-datepicker #datepicker></mat-datepicker>
                                        <img matSuffix class="example-form-img"
                                            src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                                    </mat-form-field>
                                </div>
            
                            </div>
                        </div>
            
                    </div>
            
                    <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                        <!--Spinner on Login Load-->
                        <div class="demo-container">
                            <span>{{ 'Invoice.Loading' | translate }}</span>
                            <div class="progress-bar">
                                <div class="progress-bar-value"></div>
                            </div>
                        </div>
                        <br>
                    </div>
            
                    <div *ngIf="step1">
                        <div class="container_dashboard">
                            <div class="card" style="padding: 10px; width: 98%;">
            
                                <p *ngIf="isCanadaPortal" style="font-weight: bold; font-size: 15px;">{{
                                    'paymenthistory.tableheader2' |
                                    translate }}</p>
                                <p *ngIf="!isCanadaPortal" style="font-weight: bold; font-size: 15px;">{{
                                    'paymenthistory.tableheader2'
                                    | translate }}</p>
            
                                <div *ngIf="isCanadaPortal">
                                    <div style="color: red;
                                            font-size: 15px;
                                            font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;"
                                        *ngIf="invalid">
                                        <p *ngIf="dateerror"> {{ 'paymenthistory.error' | translate }} </p>
                                        <p *ngIf="accounterror"> {{ 'paymenthistory.error1' | translate }} </p>
                                    </div>
                                </div>
                                <div *ngIf="!isCanadaPortal">
                                    <div style="color: red;
                                                font-size: 15px;
                                                font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;"
                                        *ngIf="invalid">
                                        <p *ngIf="dateerror"> {{ 'paymenthistory.error' | translate }} </p>
                                        <p *ngIf="accounterror"> {{ 'paymenthistory.error1' | translate }} </p>
                                    </div>
                                </div>
            
                                <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
            
                                    <!--US/EN Table loading-->
                                    <ng-container matColumnDef="{{column.name}}"
                                        *ngFor="let column of initPaymentTransactionColumnsStep1; last as isLast; first as isFirst;">
            
                                        <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef
                                            style=" justify-content: left;">
            
                                            <div *ngIf="column.dispFormat=='acct'">
                                                <div *ngIf="!isFrench" class="row"> {{column.display}} </div>
                                                <div *ngIf="isFrench" class="row"> {{column.displayFR}} </div>
                                            </div>
                                            <div *ngIf="column.dispFormat=='startdate'">
                                                <div *ngIf="!isFrench" class="row"> {{column.display}} </div>
                                                <div *ngIf="isFrench" class="row"> {{column.displayFR}} </div>
                                            </div>
                                            <div *ngIf="column.dispFormat=='enddate'">
                                                <div *ngIf="!isFrench" class="row"> {{column.display}} </div>
                                                <div *ngIf="isFrench" class="row"> {{column.displayFR}} </div>
                                            </div>
            
                                        </mat-header-cell>
                                        <mat-cell *matCellDef="let element" style="justify-content: left;">
            
                                            <span class="mobile-label">
                                                <div *ngIf="!isFrench && column.dispFormat !== ''"> {{column.display}} :</div>
                                                <div *ngIf="!isFrench && column.dispFormat==''"> {{column.display}} </div>
                                                <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                                            </span>
                                            <div *ngIf="column.dispFormat==''">
                                                <div class="class-test">
                                                    <mat-checkbox (click)="$event.stopPropagation();"
                                                        (change)="$event ? selection.toggle(element) : null"
                                                        [checked]="selection.isSelected(element)">
                                                    </mat-checkbox>
                                                </div>
                                            </div>
                                            <div *ngIf="column.dispFormat=='acct'"> <!--Formats Currency Columns-->
                                                {{element[column.name]}}
                                            </div>
                                            <div *ngIf="column.dispFormat=='startdate'"> <!--Formats String Columns-->
                                                <mat-form-field appearance="outline"
                                                    style="width: 63%; margin-top: 7%; height: 70px;  justify-content: center; margin-bottom: -5px;">
                                                    <input matInput [min]="minDate" [max]="maxDate"
                                                        [(ngModel)]="startDateMap[element.contractNum]"
                                                        [matDatepicker]="datepicker">
                                                    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                                                    <mat-datepicker #datepicker>
                                                        <mat-datepicker-actions>
                                                            <button mat-button matDatepickerCancel>{{ 'LoginModal.Cancel' |
                                                                translate
                                                                }}</button> &nbsp;&nbsp;
                                                            <button mat-raised-button color="primary" matDatepickerApply>{{
                                                                'LoginModal.Apply' | translate
                                                                }}</button>
                                                        </mat-datepicker-actions>
                                                    </mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                            <div *ngIf="column.dispFormat=='enddate'"> <!--Formats String Columns-->
                                                <mat-form-field appearance="outline"
                                                    style="width: 63%; margin-top: 7%; height: 70px;  justify-content: center; margin-bottom: -5px;">
                                                    <input matInput [min]="minDate" [max]="maxDate"
                                                        [(ngModel)]="endDateMap[element.contractNum]" [matDatepicker]="datepicker">
                                                    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                                                    <mat-datepicker #datepicker>
                                                        <mat-datepicker-actions>
                                                            <button mat-button matDatepickerCancel>{{ 'LoginModal.Cancel' |
                                                                translate
                                                                }}</button>&nbsp;&nbsp;
                                                            <button mat-raised-button color="primary" matDatepickerApply>{{
                                                                'LoginModal.Apply' | translate
                                                                }}</button>
                                                        </mat-datepicker-actions>
                                                    </mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                        </mat-cell>
                                    </ng-container>
            
                                    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                                    <ng-container matColumnDef="accountDetailsRes">
                                        <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                                            [attr.colspan]="displayedColumnsPaymentTransactionStep1.length">
                                        </mat-cell>
                                    </ng-container>
            
                                    <mat-header-row *matHeaderRowDef="displayedColumnsPaymentTransactionStep1"></mat-header-row>
                                    <mat-row *matRowDef="let element; columns: displayedColumnsPaymentTransactionStep1;"
                                        class="example-element-row" [class.example-expanded-row]="accountDetailsRes === element"
                                        (click)="accountDetailsRes = accountDetailsRes === element ? null : element">
                                    </mat-row>
                                    <mat-row *matRowDef="let row; columns: ['accountDetailsRes']"
                                        class="example-detail-row"></mat-row>
            
                                    <!-- Row shown when there is no matching data. -->
                                    <tr class="mat-row" *matNoDataRow>
                                        <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter
                                        </td>
                                        <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                                        </td>
                                    </tr>
            
                                </mat-table>
                                <mat-paginator [pageSizeOptions]="[5,10, 25, 100]"></mat-paginator>
                            </div>
                            <br>
                            <button class="mbfs-button" (click)="getlistAllPaymentsForSchedule()"
                                style="float: right;">{{'LoginModal.Continue' | translate }}</button>
                            <button class="mbfs-button" (click)="BacktoDashBoard()" style="float: right;">{{'LoginModal.back' |
                                translate }}</button>
                        </div>
            
                    </div>
             
           
            <div *ngIf="step2">
                <!-- payment transactions table -->
                <div class="container_dashboard" >
                    <div class="mt-4" style="padding-bottom: 15px;"> 
                        <div class="card" style="padding: 10px;">
                        <p *ngIf="isCanadaPortal" style="font-weight: bold; font-size: 15px;">{{ 'paymenthistory.tableheader2' | translate }}</p>
                        <p *ngIf="!isCanadaPortal" style="font-weight: bold; font-size: 15px;">{{ 'paymenthistory.tableheader2' | translate }}</p>
                        <!-- <dtf-onlinepaymenttable [tableData]="selectedPayment" [displayedColumns]="step2DisplayedColumns"
                        [continueBoolean]="continueBoolean" class="mt-4"></dtf-onlinepaymenttable> -->



                        <mat-table [dataSource]="dataSource1" multiTemplateDataRows class="mat-elevation-z8" matSort>

                            <!--US/EN Table loading-->
                            <ng-container matColumnDef="{{column.name}}"
                                *ngFor="let column of initPaymentTransactionColumns; last as isLast; first as isFirst;">

                                <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef
                                    style=" justify-content: left;">
                                    <!-- <div *ngIf="!isFrench"> {{column.display}}</div>
                            <div *ngIf="isFrench"> {{column.displayFR}}</div> -->
                                    <div *ngIf="column.dispFormat==''">
                                        <div *ngIf="!isFrench" class="row"> {{column.display}} </div>
                                        <div *ngIf="isFrench" class="row"> {{column.displayFR}} </div>
                                        <!-- <div class="row">

                                            <div style="display: inline-flex;">
                                                <input
                                                    style="outline: none; width: 70%; margin-top: 2%; margin-bottom: 5%; height: 20px;"
                                                    (keyup)="applyFilterAcc($event.target.value)" #input type="text">
                                                <mat-icon fontIcon="search"></mat-icon>

                                            </div>
                                        </div> -->
                                    </div>

                                    <div *ngIf="column.dispFormat=='amount'">
                                        <div *ngIf="!isFrench" class="row"> {{column.display}} </div>
                                        <div *ngIf="isFrench" class="row"> {{column.displayFR}} </div>
                                        <!-- <div class="row">

                                            <div style="display: inline-flex;">
                                                <input
                                                    style="outline: none; width: 70%; margin-top: 2%; margin-bottom: 5%;  height: 20px;"
                                                    (keyup)="applyFilterAmount($event.target.value)" #input type="text">
                                                <mat-icon fontIcon="search">
                                                </mat-icon>
                                            </div>

                                        </div> -->
                                    </div>

                                    <div *ngIf="column.dispFormat=='transactiondate'">
                                        <div *ngIf="!isFrench" class="row"> {{column.display}} </div>
                                        <div *ngIf="isFrench" class="row"> {{column.displayFR}} </div>
                                        <!-- <div class="row">
                                    <div style="display: inline-flex;">
                                        <input
                                            style="outline: none; width: 70%; height: 20px; margin-top: 4%; margin-bottom: 5%; "
                                            (keyup)="applyFilterDate($event.target.value)" #input
                                            type="date" data-date-format="MM DD YYYY">
                                        
                                        <mat-icon fontIcon="search">
                                        </mat-icon>
                                    </div>
                                </div> -->
                                    </div>

                                    <div *ngIf="column.dispFormat=='transactionid'">
                                        <div *ngIf="!isFrench" class="row"> {{column.display}} </div>
                                        <div *ngIf="isFrench" class="row"> {{column.displayFR}} </div>
                                    </div>

                                    <div *ngIf="column.dispFormat=='paymentmethod'">
                                        <div *ngIf="!isFrench" class="row"> {{column.display}} </div>
                                        <div *ngIf="isFrench" class="row"> {{column.displayFR}} </div>
                                        <!-- <div class="row">

                                            <div style="display: inline-flex;">
                                                <input
                                                    style="outline: none; width: 70%; margin-top: 2%; margin-bottom: 5%;  height: 20px;"
                                                    (keyup)="applyFilterpaymentmethod($event.target.value)" #input
                                                    type="text">
                                                <mat-icon fontIcon="search">
                                                </mat-icon>
                                            </div>

                                        </div> -->
                                    </div>


                                </mat-header-cell>
                                <mat-cell *matCellDef="let element" style="justify-content: left; margin-left: 20px;">
                                    <span class="mobile-label">
                                        <div *ngIf="!isFrench && column.dispFormat !== ''"> {{column.display}} :</div>
                                        <div *ngIf="!isFrench && column.dispFormat==''"> {{column.display}} </div>
                                        <div *ngIf="isFrench&& column.dispFormat !== ''"> {{column.displayFR}} :</div>
                                        <div *ngIf="isFrench&& column.dispFormat == ''"> {{column.displayFR}} </div>
                                    </span>
                                    <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                                        {{element[column.name] | currency:'USD':true:'1.2-2'}}
                                    </div>
                                    <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                                        {{element[column.name]}}

                                    </div>
                                    <div *ngIf="column.dispFormat=='amount'"> <!--Formats date Columns-->
                                        {{element[column.name] | currency:'USD':true:'1.2-2'}}
                                    </div>
                                    <div *ngIf="column.dispFormat=='transactiondate'"> <!--Formats date Columns-->
                                        {{element[column.name] | date:'MM/dd/yyyy'}}
                                    </div>
                                    <div *ngIf="column.dispFormat=='transactionid'">
                                        <!--Formats date Columns-->
                                        {{element[column.name]}}
                                    </div>
                                    <div *ngIf="column.dispFormat=='paymentmethod'"> <!--Formats date Columns-->
                                        {{element[column.name]}}
                                    </div>
                                </mat-cell>
                            </ng-container>

                            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                            <ng-container matColumnDef="paymentHistoryRes">
                                <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                                    [attr.colspan]="displayedColumnsPaymentTransaction.length">
                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumnsPaymentTransaction"></mat-header-row>
                            <mat-row *matRowDef="let element; columns: displayedColumnsPaymentTransaction;"
                                class="example-element-row" [class.example-expanded-row]="paymentHistoryRes === element"
                                (click)="paymentHistoryRes = paymentHistoryRes === element ? null : element">
                            </mat-row>
                            <mat-row *matRowDef="let row; columns: ['paymentHistoryRes']"
                                class="example-detail-row"></mat-row>

                            <!-- Row shown when there is no matching data. -->
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter
                                </td>
                                <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                                </td>
                            </tr>

                        </mat-table>
                        <mat-paginator [pageSizeOptions]="[5,10, 25, 100]"></mat-paginator>
                    </div>
                    <br>
                    <button class="mbfs-button" (click)="back()">{{'LoginModal.back' | translate }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
 </div>
